import ServiceManager from "../../3x1010/services/ServiceManager";
import PageCommon from "../PageCommon";
import gsap from "gsap";

const GamesConfig = {
  quiz: {
    time_by_level: [45, 30, 15],
    score_by_level: [10, 30, 50],
    star_multipliers: [1, 5, 10, 20],
  },
  memory: {
    coppie_by_level: [6, 8, 10],
    time_by_level: [120,90,60],
    tentativi_by_level: [8, 7, 6],
    time_increase_by_level: [20, 15, 10],
    tentativi_increase_by_level: [4, 3, 2],
    multiplier_by_level: [1, 5, 10]
  },
  at_glance: {
    time_by_level: [45, 30, 15],
    score_by_level: [45, 60, 75],
    star_multipliers: [1, 1.1, 1.2, 1.4],
    tile_by_level: [250, 200, 150]
  }
}
function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
}

const emptyimage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

export class Game {
  static getInstance(config, uidpath, gameEndCallback) {
    let ret = null;

    if (config.type === 'quiz') {
      ret = new GameDomande(gameEndCallback);
    }
    else if (config.type === 'memory') {
      ret = new GameMemory(gameEndCallback);
    }
    else if (config.type === 'occhio') {
      ret = new GameOcchio(gameEndCallback);
    }
    else if (config.type === 'story') {
      ret = new GameStory(gameEndCallback);
    }
    else {
      console.log('unknown game', config);
    }

    let level = 0;
    if (config.level === 'normal') {
      level = 1;
    }
    else if (config.level === 'hard') {
      level = 2;
    }

    if (ret !== null) {
      ret.init(config.mc, level, uidpath);
    }
    return ret;
  }

  constructor(gameEndCallback) {
    this.gameEndCallback = gameEndCallback;
    this.timestart = null;
    this.timer = null;

    this.countdown = null;

    this.currentCountdown = null;
    this.punti = null;
    this.stelline = null;
    this.tentativi = null;
    this.gameData = null;

    this.mouseup = this.mouseup.bind(this);

    this.destroyed = false;
  }

  init(mc, level, gameid, uidpath) {
    console.log('gameid=' + gameid + ' level=' + level + ' uidpath=' + uidpath);
    this.mc = mc;
    this.level = level;
    this.gameid = gameid;
    this.uidpath = uidpath;
    this._setCurrentCountdown(0);
    this.setStelline(3);
    this.setPunti(0);
    this.setTentativi(0);

    $(document).on('mouseup', this.mouseup);

    ServiceManager.standardCall(
      '/api/app/gameconfiguration?game=' + this.gameid + '&level=' + this.level + '&uidPath=' + this.uidpath,
      null,
      (response) => {
        if (response.StatusCode === 200 && response.Config) {
          const gd = JSON.parse(response.Config);
          if (gd) {
            if (this.destroyed) {
              console.log('destroyed');
            }
            else {
              this.initDone(gd);
            }
          }
        }
      }, 'GET');
  }

  destructor() {
    this.stopCountdown();
    this.mc = $('');
    $(document).off('mouseup', this.mouseup);
    this.destroyed = true;
  }

  mouseup() {

  }

  initDone(gamedata) {
    this.gameData = gamedata;
    console.log('gameData', this.gameData);
  }

  setStelline(stelline) {
    const _stelline = stelline + 0;
    if (_stelline >= 0 && _stelline <= 3) {
      this.stelline = _stelline;
      const hs = $('.js-hearts', this.mc);
      $('.js-heart', hs).each((_i, _h) => {
        if (_i < _stelline) {
          $(_h).removeClass('heart-empty');
        }
        else {
          $(_h).addClass('heart-empty');
        }
      });
    }
  }

  setTentativi(tentativi) {
    this.tentativi = tentativi + 0;
    $('.js-tentativi', this.mc).text(this.tentativi);
  }

  setPunti(punti) {
    this.punti = punti + 0;
    $('.js-scores', this.mc).text(this.punti);
  }

  startCountdown(countdown) {
    this.stopCountdown();
    this.countdown = countdown + 0;
    this._setCurrentCountdown(this.countdown);
    this.timestart = new Date().getTime();
    this._setTimer();
  }

  increaseCountdown(seconds) {
    this.countdown += seconds;
  }

  stopCountdown() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
  }

  timeFinished() {

  }

  _setCurrentCountdown(cc) {
    if (cc !== this.currentCountdown) {
      this.currentCountdown = cc;
      const cf = new Date(this.currentCountdown * 1000).toISOString().substring(14, 19);
      $('.js-timing', this.mc).text(cf);
      this.tic();
      //console.log(cf);
    }
  }

  tic() {

  }

  _setTimer() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this._timeCheck(), 100);
  }

  _timeCheck() {
    const elapsed = Math.floor((new Date().getTime() - this.timestart) / 1000);
    let _cc = this.countdown - elapsed;
    if (_cc < 0) {
      _cc = 0;
    }
    this._setCurrentCountdown(_cc);
    if (_cc > 0) {
      this._setTimer();
    }
    else {
      this.timeFinished();
    }
  }
}

export class GameDomande extends Game {
  // constructor(...args) {
  //     super(...args);
  // }

  init(mc, level, uidpath) {
    console.log('GameDomande.init');
    super.init(mc, level, '0', uidpath);
    this.domandaCorrente = -1;
    this.risposteDomandaCorrente = [];
    this.enabled = false;
    this.totaleCorrette = 0;
    this.tempoTotale = 0;
    $('.js-quetion-answers', this.mc).html('');
    $('.js-game-question', this.mc).text('');
    $('.js-question-image', this.mc).attr('src', emptyimage);

  }

  mouseup() {
    if (!this.enabled) return;
    $('.js-answer', this.mc).removeClass('selected');
  }

  initDone(gamedata) {
    super.initDone(gamedata);
    this.nextDomanda();
  }

  nextDomanda() {
    this.domandaCorrente++;

    const _domanda = this.gameData[this.domandaCorrente];

    if (!_domanda) {
      this.showPunteggio();
      return;
    }

    let risposte = [];
    if (_domanda.Answer1) {
      risposte.push({ giusta: false, txt: _domanda.Answer1 });
    }
    if (_domanda.Answer2) {
      risposte.push({ giusta: false, txt: _domanda.Answer2 });
    }
    if (_domanda.Answer3) {
      risposte.push({ giusta: false, txt: _domanda.Answer3 });
    }
    if (_domanda.Answer4) {
      risposte.push({ giusta: false, txt: _domanda.Answer4 });
    }

    if (risposte.length > 0) {
      risposte[0].giusta = true;
      risposte = shuffle(risposte);

      for (let i = 0; i < risposte.length; i++) {
        risposte[i].id = i + '';
      }
    }
    this.risposteDomandaCorrente = risposte;
    //console.log(this.risposteDomandaCorrente);
    $('.js-question-image', this.mc).attr('src', emptyimage);
    gsap.set(".js-question-wrapper", { xPercent: 100 });

    $('.js-game-question', this.mc).text(_domanda.Question);
    $('.js-question-image', this.mc).attr('src', _domanda.Image);

    const h_answers = $('.js-quetion-answers', this.mc);
    h_answers.html('');

    for (let i = 0; i < this.risposteDomandaCorrente.length; i++) {
      const _risp = this.risposteDomandaCorrente[i];
      const h_answer = $('<div class="answer js-answer"><p class="js-answer-txt"></p></div>');
      h_answer.attr('data-id', _risp.id);
      $('.js-answer-txt', h_answer).text(_risp.txt);
      h_answer.appendTo(h_answers);
    }


    $('.js-answer', h_answers).on('mousedown touchstart', (ev) => {
      if (!this.enabled) return;
      const h_answer = $(ev.currentTarget);
      h_answer.addClass('selected');
    });

    $('.js-answer', h_answers).on('mouseup touchend', (ev) => {
      if (!this.enabled) return;
      const h_answer = $(ev.currentTarget);
      h_answer.removeClass('selected');
    });

    $('.js-answer', h_answers).on('click', (ev) => {
      if (!this.enabled) return;
      const h_answer = $(ev.currentTarget);

      const _id = h_answer.attr('data-id');
      const domanda = this.risposteDomandaCorrente.find((_d) => _d.id === _id);
      this.answered(domanda, h_answer);
    });

    gsap.timeline({
      defaults: { duration: 0.8 }, onComplete: () => {
        this.startCountdown(GamesConfig.quiz.time_by_level[this.level]);
        this.enabled = true;
      }
    })
      .add('start')
      .to('.js-question-wrapper', { xPercent: 0 }, 'start')
      .to('.js-question-image', { opacity: 1 }, 'start');
  }

  answered(domanda, h_answer) {
    this.enabled = false;
    super.stopCountdown();
    this.tempoTotale += this.countdown - this.currentCountdown;
    console.log('tempoTotale', this.tempoTotale);

    //console.log(domanda);
    const giusta = domanda?.giusta ?? false;
    if (giusta) {
      h_answer.addClass('selected is-correct');
      this.totaleCorrette++;

      setTimeout(() => {
        this.dismissDomanda();
      }, 1500);
    }
    else {
      h_answer.addClass('selected is-wrong');
      super.setStelline(this.stelline - 1);

      setTimeout(() => {
        const idGiusta = this.risposteDomandaCorrente.find((_d) => (_d.giusta)).id;
        const h_correct = $('.js-answer[data-id="' + idGiusta + '"]', this.mc);
        h_correct.addClass('selected is-correct');
        setTimeout(() => {
          this.dismissDomanda();
        }, 1500);
      }, 1500);
    }
  }

  timeFinished() {
    this.enabled = false;

    this.tempoTotale += this.countdown;
    console.log('tempoTotale', this.tempoTotale);

    const idGiusta = this.risposteDomandaCorrente.find((_d) => (_d.giusta)).id;
    const h_answer = $('.js-answer[data-id="' + idGiusta + '"]', this.mc);
    h_answer.addClass('selected is-correct');
    super.setStelline(this.stelline - 1);
    setTimeout(() => {
      this.dismissDomanda();
    }, 2800);
  }

  dismissDomanda() {
    if (this.domandaCorrente < this.gameData.length - 1) {
      gsap.timeline({
        defaults: { duration: 0.5 }, onComplete: () => {
          this.nextDomanda();
        }
      })
        .add('start')
        .to('.js-question-wrapper', { xPercent: -100 }, 'start')
        .to('.js-question-image', { opacity: 0 }, 'start');
    }
    else {
      this.showPunteggio();
    }
  }

  showPunteggio() {
    const punteggio_a_domanda = GamesConfig.quiz.score_by_level[this.level];
    const moltiplicatore = GamesConfig.quiz.star_multipliers[this.stelline];
    let punti = this.totaleCorrette * punteggio_a_domanda * moltiplicatore;

    if (this.tempoTotale > 0) {
      punti /= this.tempoTotale;
      punti = Math.floor(punti);
    }
    this.gameEndCallback(punti);
  }
}

export class GameMemory extends Game {
  // constructor() {
  //     super();
  // }

  init(mc, level, uidpath) {
    console.log('GameMemory.init');
    super.init(mc, level, '1', uidpath);

    let wrap = $('.js-memory-wrap', this.mc);
    wrap.html('');

    for (let _level = 0; _level < GamesConfig.memory.coppie_by_level.length; _level++) {
      const _coppie = GamesConfig.memory.coppie_by_level[_level];
      if (_level === this.level) {
        wrap.addClass('card-count-' + (_coppie * 2));
      }
      else {
        wrap.removeClass('card-count-' + (_coppie * 2));
      }
    }
  }

  initDone(gamedata) {
    super.initDone(gamedata);
    //this.startCountdown(GamesConfig.quiz.time_by_level[this.level]);
    this.current_card = null;
    this.card_scoperte_ids = [];
    this.enabled = false;
    this.initialized = false;
    this.gameEnd = false;

    let images = [];
    for (let _i = 0; _i < this.gameData.length; _i++) {
      const img = {
        id: _i,
        img: this.gameData[_i].Image
      };
      images.push(img);
      images.push(img);
    }
    // if (this.gameData.length > 0) {
    //     let missing = GamesConfig.memory.coppie_by_level[this.level] - this.gameData.length;
    //     while (missing > 0) {
    //         const _i = Math.floor(Math.random() * this.gameData.length);
    //         const img = {
    //             id: _i,
    //             img: this.gameData[_i].Image
    //         };
    //         images.push(img);
    //         images.push(img);
    //         missing--;
    //     }
    // }
    images = shuffle(images);
    //console.log(images);

    let wrap = $('.js-memory-wrap', this.mc);

    for (let _card of images) {
      const card = `<figure class="memory-card js-memory-card" data-id="${_card.id}">
                <div class="memory-card-wrap">
                  <img class="card-back js-card-back" src="/assets/card-retro.jpg" loading="lazy" />
                  <img class="card-front js-card-front" src="${_card.img}" loading="lazy" />
                </div>
            </figure>`;

      $(card).appendTo(wrap);
    }

    $('.js-memory-card', wrap).flip({
      front: '.card-back',
      back: '.card-front',
      forceWidth: true,
      forceHeight: true,
      trigger: 'manual'
    });

    $('.js-memory-card', wrap).on('click', (ev) => {
      if (!this.enabled || this.gameEnd) {
        return;
      }
      const clicked = $(ev.currentTarget);
      const idClicked = clicked.attr('data-id');

      if (this.card_scoperte_ids.indexOf(idClicked) !== -1) {
        console.log('già girata, esco');
        return;
      }

      if (this.current_card !== null && this.current_card.get(0) === ev.currentTarget) {
        console.log('già girata, esco (carta corrente)');
        return;
      }
      //$('.js-memory-card', wrap).css('border','3px hidden red');
      if (this.current_card === null) {
        this.current_card = clicked;
        $(clicked).flip(true);
        //$('.js-memory-card[data-id="'+idClicked+'"]', wrap).css('border','3px solid red');
      }
      else {
        const ok = (idClicked === this.current_card.attr('data-id'));
        if (ok) {
          console.log('trovata!');
          super.setTentativi(this.tentativi + GamesConfig.memory.tentativi_increase_by_level[this.level]);
          super.increaseCountdown(GamesConfig.memory.time_increase_by_level[this.level]);
          this.card_scoperte_ids.push(idClicked);
          this.current_card = null;

          if (this.card_scoperte_ids.length === this.gameData.length) {
            this.stopCountdown();
            this.updateScore();
            this.gameEnd = true;
            $(clicked).flip(true, () => {
              setTimeout(() => {
                this.showPunteggio();
              }, 1500);
            });
          }
          else {
            this.updateScore();
            $(clicked).flip(true);
          }
        }
        else {
          console.log('sbagliato');
          super.setTentativi(this.tentativi - 1);

          $(clicked).flip(true);
          this.enabled = false;
          setTimeout(() => {
            if (this.tentativi == 0) {
              this.gameOver();
              return;
            }

            Promise.all([
              //$('.js-card-front',clicked).fadeOut(500,()=>{}).promise(),
              //$('.js-card-front',this.current_card).fadeOut(500,()=>{}).promise()
              new Promise((resolve, reject) => {
                $(clicked).flip(false, () => { resolve(true) });
              }),
              new Promise((resolve, reject) => {
                $(this.current_card).flip(false, () => { resolve(true) });
              })
            ]).then((values) => {
              this.current_card = null;
              this.enabled = true;
            });
          }, 1800);
          this.updateScore();
        }
      }

    });

    this.setTentativi(GamesConfig.memory.tentativi_by_level[this.level]);
    this.startCountdown(GamesConfig.memory.time_by_level[this.level]);
    this.enabled = true;
    this.initialized = true;
  }

  updateScore() {
    this.setPunti(this.calcPunteggio());
  }

  tic() {
    if (this.initialized) {
      this.updateScore();
    }
  }

  calcPunteggio() {
    let ret = this.card_scoperte_ids.length * Math.pow(this.tentativi,2);
    if (ret>1)ret=Math.log(ret);
    ret*=GamesConfig.memory.multiplier_by_level[this.level]*this.currentCountdown/20;
    ret = Math.floor(ret);
    return ret;
  }

  timeFinished() {
    this.gameOver();
  }

  gameOver() {
    this.gameEnd = true;
    this.stopCountdown();
    console.log('game over');
    $('.js-memory-card').flip(true);
    setTimeout(() => {
      this.gameEndCallback(this.calcPunteggio());
    }, 3000)
  }

  showPunteggio() {
    this.gameEndCallback(this.calcPunteggio());
  }
}

export class GameOcchio extends Game {
  constructor(...args) {
    super(...args);

    this.confirm = this.confirm.bind(this);
    this.imgpan = this.imgpan.bind(this);
  }

  init(mc, level, uidpath) {
    console.log('GameOcchio.init');
    super.init(mc, level, '2', uidpath);

    $('.js-to-choose-wrap', this.mc).html('');
    $('.js-fig-choosed img', this.mc).attr('src', emptyimage);
    $('.js-fig-to-find img', this.mc).attr('src', emptyimage);

  }

  initDone(gamedata) {
    super.initDone(gamedata);
    //this.startCountdown(GamesConfig.quiz.time_by_level[this.level]);
    this.imageSet = [];
    this.imageSetIdx = 0;
    this.choosedInSetIdx = null;
    this.enabled = false;

    //this.giuste = 0;
    //this.tempoTotale = 0;
    this.punteggio = 0;

    if (this.gameData.length > 0) {
      this.next();
    }

    $('.js-btn-confirm', this.mc).on('click', null, { end: false }, this.confirm);

    const figchoosed = $('.js-fig-choosed', this.mc).get(0);
    figchoosed.addEventListener("touchmove", this.imgpan, { passive: true });
    figchoosed.addEventListener("mousemove", this.imgpan, { passive: true });

  }

  imgpan(e) {
    if (!this.enabled) return;
    //console.log(e);
    const target = e.clientX ? e : e.changedTouches[0];
    const rect = e.currentTarget.getBoundingClientRect();
    const x = Math.min(Math.max(0, target.clientX - rect.x), rect.width);
    const y = Math.min(Math.max(0, target.clientY - rect.y), rect.height);

    const imgrect = $('img', e.currentTarget).get(0).getBoundingClientRect();
    //console.log(`x=${x},y=${y},rw=${rect.width},rh=${rect.height},iw=${imgrect.width},ih=${imgrect.height}`);
    let sx = (imgrect.width - rect.width) * x / rect.width;
    let sy = (imgrect.height - rect.height) * y / rect.height;

    if (e.type === 'touchmove') {
      sx = (imgrect.width - rect.width) - sx;
      sy = (imgrect.height - rect.height) - sy;
    }
    //console.log(`sx=${sx},sy=${sy}`);

    e.currentTarget.scrollTop = sy;
    e.currentTarget.scrollLeft = sx;

  }

  destructor() {
    $('.js-btn-confirm', this.mc).off('click', this.confirm);
    const figchoosed = $('.js-fig-choosed', this.mc).get(0);
    figchoosed.removeEventListener("touchmove", this.imgpan, false);
    figchoosed.removeEventListener("mousemove", this.imgpan, false);

    super.destructor();
  }

  next() {
    {
      const _currentSet = this.gameData[this.imageSetIdx];
      this.imageSet = [];
      for (let _i = 0; _i < _currentSet.length; _i++) {
        this.imageSet.push({
          //id:_i,
          giusta: (_i === 0),
          img: _currentSet[_i],
        });
      }
      this.imageSet = shuffle(this.imageSet);
    }
    console.log(this.imageSet);

    if (this.imageSet.length === 0) return;

    $('.js-fig-to-find img', this.mc).attr('src', this.imageSet.find((_img) => _img.giusta).img.Base64TileImage);

    const wrap = $('.js-to-choose-wrap', this.mc);
    wrap.html('');

    for (let _i = 0; _i < this.imageSet.length; _i++) {
      const _img = this.imageSet[_i];
      const fig = $(`<figure class="js-fig-to-choose" data-id="${_i}">
                <img src="${_img.img.Image}" loading="lazy" />
            </figure>`);
      fig.appendTo(wrap);
    }

    this.choosedInSetIdx = null;
    //this.select(0,true);
    this.setImageChoosed('/assets/placeholder-occhio.jpg', false);


    $('.js-fig-to-choose', this.mc).on('click', (ev) => {
      if (!this.enabled) return;

      const clicked = $(ev.currentTarget);
      const clickedId = clicked.attr('data-id');
      const clickedData = this.imageSet[clickedId];

      console.log(clickedId, clickedData);

      this.choosedInSetIdx = clickedId;
      this.select(clickedId, true);
    });

    this.imageSetIdx++;

    $('.js-occhio-wrap', this.mc).fadeIn(400, () => {
      this.startCountdown(GamesConfig.at_glance.time_by_level[this.level]);
      this.enabled = true;
    });
  }

  select(idx, full, correct = null) {
    const wrap = $('.js-to-choose-wrap', this.mc);
    $('.js-fig-to-choose', wrap).removeClass('selected is-wrong is-correct');

    let _class = 'selected';
    if (correct === true) {
      _class += ' is-correct';
    }
    else if (correct === false) {
      _class += ' is-wrong';
    }

    $('.js-fig-to-choose[data-id="' + idx + '"]', wrap).addClass(_class);

    let sameImage = this.imageSet[idx].img.Image === $('.js-fig-choosed img', this.mc).attr('src');
    if (!sameImage) {
      this.setImageChoosed(this.imageSet[idx].img.Image, full);
    }
  }
  setImageChoosed(imageUrl, full) {
    $('.js-fig-choosed img', this.mc).attr('src', emptyimage);

    if (full) {
      $('.js-fig-choosed img', this.mc).addClass('imgzoom');
    }
    else {
      $('.js-fig-choosed img', this.mc).removeClass('imgzoom');
    }
    $('.js-fig-choosed img', this.mc).attr('src', imageUrl);
  }

  timeFinished() {
    //this.tempoTotale += this.countdown;
    //console.log('tempoTotale', this.tempoTotale);
    this.confirm({ data: { end: true } });
  }

  confirm(ev) {
    if (!this.enabled) return;
    if (this.choosedInSetIdx === null && !ev.data.end) {
      return;
    }
    this.enabled = false;

    super.stopCountdown();
    //this.tempoTotale += this.countdown - this.currentCountdown;
    //console.log('tempoTotale', this.tempoTotale);

    let giusta = false;
    const giustaIdx = this.imageSet.findIndex((_img) => _img.giusta) ?? null;
    if (giustaIdx !== null && (this.choosedInSetIdx + '' === giustaIdx + '')) {
      //this.giuste++;
      giusta = true;
    }
    else {
      this.setStelline(this.stelline - 1);
    }
    const moltiplicatore = GamesConfig.at_glance.star_multipliers[this.stelline];
    if (giusta) {
      this.punteggio += this.calcPunteggio(this.countdown - this.currentCountdown);
    }
    this.setPunti(Math.round(this.punteggio*moltiplicatore));

    const figchoosed = $('.js-fig-choosed', this.mc).get(0);
    figchoosed.scrollTop = 0;
    figchoosed.scrollLeft = 0;

    if (giusta || this.choosedInSetIdx === null) {
      this.select(giustaIdx, false, true);
      this.confirm2();
    }
    else {
      this.select(this.choosedInSetIdx, false, false);
      setTimeout(() => {
        this.select(giustaIdx, false, true);
        this.confirm2();
      }, 2000);
    }
  }

  confirm2() {
    setTimeout(() => {
      $('.js-occhio-wrap', this.mc).fadeOut(400, () => {
        setTimeout(() => {
          if (this.imageSetIdx < this.gameData.length) {
            this.next();
          }
          else {
            this.gameEndCallback(this.punti);
          }
        }, 50);
      });
    }, 2000);
  }

  calcPunteggio(tempo) {
    const puntigiuste = GamesConfig.at_glance.score_by_level[this.level];

    let punti = /*this.giuste * */puntigiuste; /* * moltiplicatore;*/
    
    if (tempo > 0) {
      punti /= tempo;
      //punti = Math.floor(punti);
    }
    console.log(`punti parziali= ${puntigiuste} puntidomanda /${tempo} tempo =${punti}`);
    return punti;
  }

}

export class GameStory extends Game {
  // constructor(...args) {
  //     super(...args);
  // }

  init(mc, level, uidpath) {
    console.log('GameDomande.init');
    super.init(mc, level, '3', uidpath);
  }

  initDone(gamedata) {
    super.initDone(gamedata);
    const wrap = $('.js-story-wrap');    
    //wrap.html('');
    if ($(".js-swiper-story", wrap)) {
      $(".js-swiper-story", wrap).remove();
    }
    const swiperstory = `
      <div class="swiper swiper-story js-swiper-story">
        <div class="swiper-wrapper"></div>
        <div class="swiper-button swiper-button-next js-story-btn-next"></div>
        <div class="swiper-button swiper-button-prev js-story-btn-prev"></div>
      </div>
      `;
    $(swiperstory).appendTo(wrap);
    for (let _st of gamedata) {
      let img = _st.Image;
      let url = _st.TargetUrl;
      const card = `
        <div class="swiper-slide">
          <div>
            <img src="${img}"/>
            <a class="btn btn-secondary btn-story-cta-download" href="${url}" target="_blank">Scarica il pacchetto</a>
          </div>
        </div>
      `;
      $(card).appendTo($(".swiper-wrapper", ".js-swiper-story"));
    }
    let storyswiper = new Swiper(document.querySelector(".js-swiper-story"), {
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: ".js-story-btn-next",
        prevEl: ".js-story-btn-prev"
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },        
        992: {
          slidesPerView: 4
        },
      },
    });
    setTimeout(() => {
      $(".gl-bottom", ".game-story").height($(".game-story").height() - $(".gl-top", ".game-story").height() - $(".gl-level", ".game-story").height() - 68);      
      wrap.fadeIn();
    }, 400);
  }
}